/*
 * Mersi B2B — Pre-Purchase Delivery Estimate (Task 3)
 * ------------------------------------------------------------------
 * Resolution order for the date:
 *   1. CLIENT-SIDE from cached config (window.MERSI_SHIP_CONFIG) — instant, no
 *      network, works even if Command Center is down. Command Center PUSHES that
 *      config into a shop metafield (config-sync.ts); the theme just mirrors it.
 *      This is a single-center approximation using zipCenterHints (softened as
 *      "usually ships from…").
 *   2. Command Center endpoint (/apps/mersi/api/storefront/delivery-estimate) —
 *      used when there's no cached config, OR to get stock-accurate center
 *      selection and SPLIT-SHIPMENT breakdown the client can't compute.
 *   3. Safe fallback ("Most orders arrive in 2–3 business days").
 *
 * Works on product page, cart page, and the slide-out cart drawer (idempotent +
 * re-inits on drawer re-render).
 */
(function () {
  var DRAWER_SELECTORS = "cart-drawer, #CartDrawer, .cart-drawer, .drawer, #cart-drawer";
  var USE_SERVER_FOR_SPLIT = true; // prefer server when a cart may split across centers

  function initAll() {
    document.querySelectorAll(".mersi-eta-widget").forEach(function (w) {
      if (w.dataset.mersiInit === "1") return;
      w.dataset.mersiInit = "1";
      initWidget(w);
    });
  }

  function initWidget(w) {
    var base = w.dataset.proxyBase || "/apps/mersi";
    var compact = w.dataset.context === "drawer" || w.classList.contains("eta--compact");
    var $ = function (el) { return w.querySelector('[data-el="' + el + '"]'); };
    var countdownTimer = null;

    function currentItems() {
      return fetch("/cart.js").then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (cart && cart.items && cart.items.length) {
            return cart.items.map(function (i) { return { sku: i.sku, qty: i.quantity }; });
          }
          return [];
        }).catch(function () { return []; });
    }
    function resolveZip() {
      var field = document.querySelector('[name="address[zip]"],[name="checkout[shipping_address][zip]"],#mersi-zip');
      if (field && field.value) return field.value.trim();
      return w.dataset.defaultZip || ""; // customer.default_address.zip, rendered by the snippet
    }

    function load() {
      var zip = resolveZip();
      currentItems().then(function (items) {
        var cfg = window.MERSI_SHIP_CONFIG;
        // 1) client-side compute when we have config + zip (and not deferring to server for split)
        if (cfg && zip && !USE_SERVER_FOR_SPLIT) {
          var local = computeFromConfig(cfg, zip);
          if (local) return render(local);
        }
        // 2) server (stock-accurate + split); still passes the account zip
        var qs = new URLSearchParams({ zip: zip, country: "US", items: JSON.stringify(items) });
        fetch(base + "/api/storefront/delivery-estimate?" + qs.toString(), { credentials: "include" })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.resolved) return render(d);
            // 3) fall back to client-side config if server couldn't resolve
            var local = cfg && zip ? computeFromConfig(cfg, zip) : null;
            return local ? render(local) : renderFallback(d);
          })
          .catch(function () {
            var local = cfg && zip ? computeFromConfig(cfg, zip) : null;
            return local ? render(local) : renderFallback();
          });
      });
    }

    function render(d) {
      if (!d || !d.resolved) return renderFallback(d);
      var lead = $("lead"), sub = $("sub"), from = $("from");
      var fromVerb = d.predicted ? "usually ships from" : "ships from";

      // SPLIT SHIPMENT — headline = latest date; sub lists the shipments.
      if (d.split && d.groups && d.groups.length > 1) {
        lead.innerHTML = "Arrives by <span class='mersi-eta-date'>" + fmtDate(d.deliveryDate) + "</span>";
        sub.innerHTML = "Ships in " + d.groups.length + " shipments · " +
          d.groups.map(function (g) { return esc(g.center) + " by " + fmtDate(g.deliveryDate); }).join(" · ");
        if (from) from.hidden = true;
        if (!d.cutoffPassed && d.cutoffLocal) startCountdown(d.cutoffLocal);
        return;
      }

      if (compact) {
        lead.innerHTML = "Get it by <span class='mersi-eta-date'>" + fmtDate(d.deliveryDate) + "</span>";
        sub.innerHTML = d.cutoffPassed
          ? "Ships next business day from " + esc(d.fulfillmentCenter)
          : "Order within <span class='mersi-eta-clock' data-el='cd'></span> · " + fromVerb + " " + esc(d.fulfillmentCenter);
        if (!d.cutoffPassed && d.cutoffLocal) startCountdown(d.cutoffLocal);
        if (from) from.hidden = true;
        return;
      }

      if (d.cutoffPassed || !d.cutoffLocal) {
        lead.innerHTML = "Order today to get it by <span class='mersi-eta-date'>" + fmtDate(d.deliveryDate) + "</span>";
        sub.textContent = "Cut-off passed — ships next business day from " + d.fulfillmentCenter;
      } else {
        lead.innerHTML = "Order by <span class='mersi-eta-clock'>" + fmtTime(d.cutoffLocal) +
          "</span> to get it by <span class='mersi-eta-date'>" + fmtDate(d.deliveryDate) + "</span>" +
          "<span class='mersi-countdown' data-el='cd'></span>";
        sub.textContent = cap(fromVerb) + " " + d.fulfillmentCenter +
          (d.transitDays ? " · " + d.transitDays + " business days in transit" : "");
        startCountdown(d.cutoffLocal);
      }
      if (from) {
        from.hidden = false;
        from.innerHTML = "<span class='pin'></span> " + cap(fromVerb) + " your nearest center — <strong>" +
          esc(d.fulfillmentCenter) + "</strong>";
      }
    }

    function renderFallback(d) {
      $("lead").innerHTML = "Most orders arrive in <span class='mersi-eta-date'>2–3 business days</span>";
      // Actionable ZIP entry so logged-out visitors (and the theme preview) get an exact date.
      $("sub").innerHTML = "Enter ZIP for an exact date: " +
        "<input id='mersi-zip' inputmode='numeric' maxlength='5' placeholder='ZIP' " +
        "style='width:74px;padding:3px 8px;border:1px solid rgba(55,65,81,.35);border-radius:6px;font:inherit;margin-left:4px'>";
      if ($("from")) $("from").hidden = true;
      var zf = w.querySelector("#mersi-zip");
      if (zf) zf.addEventListener("input", function () { if (zf.value.replace(/\D/g, "").length === 5) load(); });
    }

    function startCountdown(cutoffIso) {
      var cdEl = w.querySelector('[data-el="cd"]');
      if (!cdEl) return;
      if (countdownTimer) clearInterval(countdownTimer);
      function tick() {
        var ms = new Date(cutoffIso) - new Date();
        if (ms <= 0) { clearInterval(countdownTimer); load(); return; }
        var h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
        cdEl.textContent = "⏱ " + h + "h " + m + "m left";
      }
      tick(); countdownTimer = setInterval(tick, 30000);
    }

    document.addEventListener("change", function (e) {
      if (e.target.matches('[name="quantity"],[name="address[zip]"],#mersi-zip,[name="checkout[shipping_address][zip]"]')) load();
    });
    load();
  }

  /* ---- CLIENT-SIDE compute from cached config (single-center approximation) ---- */
  function computeFromConfig(cfg, zip) {
    try {
      var z3 = zip.slice(0, 3), z1 = zip.slice(0, 1);
      var hints = cfg.zipCenterHints || {};
      var ranked = hints[z3] || hints[z1] || Object.keys(cfg.warehouses || {});
      var warehouse = ranked[0];
      if (!warehouse) return null;
      var wh = cfg.warehouses[warehouse] || {};
      var holidays = {}; (cfg.holidays || []).forEach(function (d) { holidays[d] = 1; });
      var isBiz = function (dt) { var g = dt.getDay(); return g !== 0 && g !== 6 && !holidays[iso(dt)]; };
      var nextBiz = function (dt) { var n = new Date(dt); do { n.setDate(n.getDate() + 1); } while (!isBiz(n)); return n; };
      var addBiz = function (dt, n) { var d = new Date(dt); while (n > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) n--; } return d; };

      var now = new Date();
      // cutoff today in the warehouse tz (approx: use local device tz; server value is authoritative)
      var parts = (wh.cutoff || "14:00").split(":");
      var cutoff = new Date(now); cutoff.setHours(+parts[0], +parts[1], 0, 0);
      var cutoffPassed = now > cutoff;
      var start = new Date(now); start.setHours(0, 0, 0, 0);
      var shipDate = cutoffPassed || !isBiz(start) ? nextBiz(start) : start;

      var lane = (cfg.transitMatrix || {})[warehouse] || {};
      var transitDays = lane[z3] != null ? lane[z3] : (lane[z1] != null ? lane[z1] : 3);
      var delivery = addBiz(shipDate, transitDays + (cfg.bufferBusinessDays || 0));

      return {
        resolved: true, split: false, predicted: true,
        fulfillmentCenter: wh.city || warehouse, transitDays: transitDays,
        cutoffLocal: cutoffPassed ? null : cutoff.toISOString(), cutoffPassed: cutoffPassed,
        deliveryDate: delivery.toISOString(),
      };
    } catch (e) { return null; }
  }

  /* ---- keep alive across cart-drawer re-renders ---- */
  function watchDrawer() {
    var drawer = document.querySelector(DRAWER_SELECTORS);
    if (!drawer || drawer.dataset.mersiObserved === "1") return;
    drawer.dataset.mersiObserved = "1";
    new MutationObserver(function () { initAll(); }).observe(drawer, { childList: true, subtree: true });
  }
  ["cart:updated", "cart:refresh", "cart:change", "shopify:section:load"].forEach(function (ev) {
    document.addEventListener(ev, function () { initAll(); watchDrawer(); });
  });
  if (document.readyState !== "loading") { initAll(); watchDrawer(); }
  else document.addEventListener("DOMContentLoaded", function () { initAll(); watchDrawer(); });

  /* ---- formatting ---- */
  function fmtDate(x) { return new Date(x).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }); }
  function fmtTime(x) { return new Date(x).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", timeZoneName: "short" }); }
  function iso(d) { return d.toISOString().slice(0, 10); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }
})();
